import { Component, Injectable, Inject, Optional, Injector, ContentChild, TemplateRef, HostListener, ViewChild, Input, Directive, ComponentFactoryResolver, ViewContainerRef, isDevMode, NgModule } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { distinctUntilChanged, pluck, take } from 'rxjs/operators';
import { EnvironmentService } from '@mt-ng2/environment-module';
import { AuthService, ClaimsService } from '@mt-ng2/auth-module';
import { KeyboardShortcutHelpWindowService, KeyboardShortcutModule } from '@mt-ng2/keyboard-shortcuts-module';
import { NavModuleConfigToken, NavContentDynamicHeaderComponent, NavContentDynamicRowComponent, NavSidebarServiceToken } from '@mt-ng2/nav-module-config';
import { common } from '@mt-ng2/common-functions';
import { Router, RouterModule } from '@angular/router';
import { AccessRequestsModuleConfigService } from '@mt-ng2/access-requests-module-config';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { trigger, transition, style, animate } from '@angular/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@mt-ng2/environment-module';
import * as ɵngcc3 from '@mt-ng2/auth-module';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from '@angular/common';
import * as ɵngcc7 from 'ngx-keyboard-shortcuts';

const _c0 = function () { return ["/"]; };
const _c1 = ["dropdownToggleTemplate"];
const _c2 = ["dropdownMenuTemplate"];
function HeaderCurrentUserDetailsComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function HeaderCurrentUserDetailsComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelementStart(4, "b", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.userName);
} }
function HeaderCurrentUserDetailsComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function HeaderCurrentUserDetailsComponent_ng_container_19_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p", 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r4.customUserDetailsHtml, ɵngcc0.ɵɵsanitizeHtml);
} }
function HeaderCurrentUserDetailsComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtext(2, "\n                            ");
    ɵngcc0.ɵɵelement(3, "img", 9);
    ɵngcc0.ɵɵtext(4, "\n                            ");
    ɵngcc0.ɵɵelementStart(5, "p");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n                            ");
    ɵngcc0.ɵɵtemplate(8, HeaderCurrentUserDetailsComponent_ng_container_19_p_8_Template, 1, 1, "p", 10);
    ɵngcc0.ɵɵtext(9, "\n                            ");
    ɵngcc0.ɵɵelementStart(10, "button", 11);
    ɵngcc0.ɵɵlistener("click", function HeaderCurrentUserDetailsComponent_ng_container_19_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.logout(); });
    ɵngcc0.ɵɵtext(11, "Sign out");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n                        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("src", ctx_r3.userImageUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                                ", ctx_r3.userName, "\n                            ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.customUserDetailsHtml);
} }
const _c3 = function (a0, a1, a2) { return { userName: a0, userImageUrl: a1, logout: a2 }; };
const _c4 = ".navbar-nav.nav-header-button[_ngcontent-%COMP%]{color:#fff;cursor:pointer;max-height:50px;min-width:30px;text-align:center}.navbar-nav.nav-header-button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff}.navbar-nav.nav-header-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{height:50px;line-height:50px;white-space:nowrap}.navbar-nav.nav-header-button[_ngcontent-%COMP%]:hover{background:rgba(0,0,0,.15)}";
function HeaderNewTabComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function HeaderNewTabComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function HeaderNewTabComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.openInNewTab(); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "a");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "i", 3);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = function (a0, a1) { return { openInNewTab: a0, showNewTabButton: a1 }; };
function HeaderShortcutHelpComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function HeaderShortcutHelpComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function HeaderShortcutHelpComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.openShortcutHelp(); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "span", 4);
    ɵngcc0.ɵɵtext(5, " Shortcuts ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c6 = function (a0, a1) { return { openShortcutHelp: a0, showShortcutHelpButton: a1 }; };
function HeaderSubmitHelpComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function HeaderSubmitHelpComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function HeaderSubmitHelpComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.submitHelp(); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "span", 4);
    ɵngcc0.ɵɵtext(5, " Help ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c7 = function (a0) { return { submitHelp: a0 }; };
const _c8 = ["setting"];
function NavMenuItemComponent_a_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function NavMenuItemComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function NavMenuItemComponent_a_0_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.toggleExpand(); });
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_a_0_ng_container_2_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtext(3, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NavMenuItemComponent_a_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function NavMenuItemComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_a_2_ng_container_2_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtext(3, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("keyboardShortcut", ctx_r1.rowItem.shortcut)("routerLink", ctx_r1.rowItem.link.link)("queryParams", ctx_r1.rowItem.link.queryParams)("fragment", ctx_r1.rowItem.link.fragment);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NavMenuItemComponent_a_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function NavMenuItemComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵtext(1, "\n    ");
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_a_4_ng_container_2_Template, 2, 0, "ng-container", 5);
    ɵngcc0.ɵɵtext(3, "\n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.rowItem.link.link)("queryParams", ctx_r2.rowItem.link.queryParams)("fragment", ctx_r2.rowItem.link.fragment);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NavMenuItemComponent_ng_template_6_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 11, 12);
    ɵngcc0.ɵɵlistener("click", function NavMenuItemComponent_ng_template_6_a_5_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.stopProp($event); });
    ɵngcc0.ɵɵtext(2, "\n            ");
    ɵngcc0.ɵɵelement(3, "i", 13);
    ɵngcc0.ɵɵtext(4, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r10.rowItem.settingsLink.link)("queryParams", ctx_r10.rowItem.settingsLink.queryParams)("fragment", ctx_r10.rowItem.settingsLink.fragment);
} }
function NavMenuItemComponent_ng_template_6_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵlistener("click", function NavMenuItemComponent_ng_template_6_a_7_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.stopProp($event); });
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelement(2, "i", 15);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r11.rowItem.addLink.link)("queryParams", ctx_r11.rowItem.addLink.queryParams)("fragment", ctx_r11.rowItem.addLink.fragment);
} }
function NavMenuItemComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "\n    ");
    ɵngcc0.ɵɵelement(1, "div");
    ɵngcc0.ɵɵtext(2, "\n    ");
    ɵngcc0.ɵɵelementStart(3, "span", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵtemplate(5, NavMenuItemComponent_ng_template_6_a_5_Template, 5, 3, "a", 9);
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵtemplate(7, NavMenuItemComponent_ng_template_6_a_7_Template, 4, 3, "a", 10);
    ɵngcc0.ɵɵtext(8, "\n    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("menu-img ", ctx_r4.rowItem.icon, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("active", ctx_r4.rowItem.link ? ctx_r4.router.isActive(ctx_r4.rowItem.link.link, true) : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n        ", ctx_r4.rowItem.content, "\n        ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.ShowSettings);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.ShowAdd);
} }
function AppFooterComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r1.footerHtml, ɵngcc0.ɵɵsanitizeHtml);
} }
function AppFooterComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵlistener("click", function AppFooterComponent_div_1_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.goToMilesSite(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "i");
    ɵngcc0.ɵɵtext(3, "powered by");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\u00A0");
    ɵngcc0.ɵɵelementStart(5, "strong", 6);
    ɵngcc0.ɵɵtext(6, "MilesTechnologies.com");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
function AppFooterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, AppFooterComponent_div_1_div_2_Template, 1, 1, "div", 2);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵtemplate(4, AppFooterComponent_div_1_div_4_Template, 8, 0, "div", 3);
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerHtml !== "useDefaultMilesFooter");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerHtml === "useDefaultMilesFooter");
} }
function SidebarCurrentUserDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c9 = function (a0) { return [a0]; };
function SidebarCurrentUserDetailsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelement(4, "img", 4);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementStart(9, "p");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "a", 6);
    ɵngcc0.ɵɵtext(13, "Edit my Profile");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n            ");
    ɵngcc0.ɵɵelementStart(16, "i", 7);
    ɵngcc0.ɵɵlistener("click", function SidebarCurrentUserDetailsComponent_div_3_Template_i_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.toggleSidebarCollapse(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("src", ctx_r1.userImageUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.userName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(7, _c9, ctx_r1.myProfilePath));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassProp("fa-arrow-right", ctx_r1.sidebarCollapsed)("fa-arrow-left", !ctx_r1.sidebarCollapsed);
} }
function SidebarContentSectionComponent_ng_container_2_ul_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 4);
    ɵngcc0.ɵɵlistener("click", function SidebarContentSectionComponent_ng_container_2_ul_2_Template_ul_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const content_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggleExpanded(content_r1.header); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelement(2, "li", 5);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("cursor", content_r1.header.canToggleExpand ? "pointer" : "default");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", content_r1.header.content, ɵngcc0.ɵɵsanitizeHtml);
} }
function SidebarContentSectionComponent_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const content_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("componentRef", content_r1.headerComponent)("item", content_r1.header);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_app_nav_menu_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-nav-menu-item", 12);
} if (rf & 2) {
    const row_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("rowItem", row_r11);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const row_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    const content_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("componentRef", row_r11.getRowComponent(content_r1.rowComponent))("item", row_r11);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_app_nav_menu_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-nav-menu-item", 12);
} if (rf & 2) {
    const childRow_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("rowItem", childRow_r19);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const childRow_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    const content_r1 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵproperty("componentRef", childRow_r19.getRowComponent(content_r1.rowComponent))("item", childRow_r19);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_app_nav_menu_item_2_Template, 1, 1, "app-nav-menu-item", 10);
    ɵngcc0.ɵɵtext(3, "\n                            ");
    ɵngcc0.ɵɵtemplate(4, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_ng_container_4_Template, 1, 2, "ng-container", 2);
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const childRow_r19 = ctx.$implicit;
    const content_r1 = ɵngcc0.ɵɵnextContext(4).$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !childRow_r19.rowHasComponent(content_r1.rowComponent));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r18.sidebarCollapsed && childRow_r19.rowHasComponent(content_r1.rowComponent) && ctx_r18.showMe(childRow_r19));
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 13);
    ɵngcc0.ɵɵtext(1, "\n                        ");
    ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_li_2_Template, 6, 2, "li", 0);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("display", row_r11.expanded ? "block" : "none");
    ɵngcc0.ɵɵproperty("@childRowAnim", undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", row_r11.children);
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_app_nav_menu_item_2_Template, 1, 1, "app-nav-menu-item", 10);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵtemplate(4, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ng_container_4_Template, 1, 2, "ng-container", 2);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵtemplate(6, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_ul_6_Template, 4, 4, "ul", 11);
    ɵngcc0.ɵɵtext(7, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r11 = ctx.$implicit;
    const content_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !row_r11.rowHasComponent(content_r1.rowComponent));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.sidebarCollapsed && row_r11.rowHasComponent(content_r1.rowComponent) && ctx_r10.showMe(row_r11));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", row_r11.children && row_r11.children.length && row_r11.expanded && ctx_r10.showMe(row_r11));
} }
function SidebarContentSectionComponent_ng_container_2_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 7);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_ul_6_li_2_Template, 8, 3, "li", 8);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("@childRowAnim", undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", content_r1.rows);
} }
function SidebarContentSectionComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_ul_2_Template, 4, 3, "ul", 1);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵtemplate(4, SidebarContentSectionComponent_ng_container_2_ng_container_4_Template, 1, 2, "ng-container", 2);
    ɵngcc0.ɵɵtext(5, "\n            ");
    ɵngcc0.ɵɵtemplate(6, SidebarContentSectionComponent_ng_container_2_ul_6_Template, 4, 2, "ul", 3);
    ɵngcc0.ɵɵtext(7, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const content_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !content_r1.headerHasComponent);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.sidebarCollapsed && content_r1.headerHasComponent && ctx_r0.showMe(content_r1.header));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", content_r1.header.expanded);
} }
class NavComponent {
    constructor() { }
    ngOnInit() { }
}
NavComponent.ɵfac = function NavComponent_Factory(t) { return new (t || NavComponent)(); };
NavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavComponent, selectors: [["app-nav"]], decls: 4, vars: 0, template: function NavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, " ");
        ɵngcc0.ɵɵelement(1, "app-nav-header");
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵelement(3, "app-nav-sidebar");
    } }, directives: function () { return [NavHeaderComponent, NavSidebarComponent]; }, encapsulation: 2 });
NavComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavComponent, [{
        type: Component,
        args: [{
                selector: 'app-nav',
                template: ` <app-nav-header></app-nav-header>
        <app-nav-sidebar></app-nav-sidebar>`
            }]
    }], function () { return []; }, null); })();

const state = {
    navbar: { sideBarCollapsed: false, showNav: true },
};
class NavService {
    constructor(http, environmentService, authService, navModuleConfig, injector) {
        this.http = http;
        this.environmentService = environmentService;
        this.authService = authService;
        this.navModuleConfig = navModuleConfig;
        this.injector = injector;
        this.submitHelpUrl = (this.navModuleConfig && this.navModuleConfig.submitHelpUrl) || 'http://submit-help.rmm.milesapp.com';
        this.isCustomSubmitHelpPage = (this.navModuleConfig && this.navModuleConfig.isCustomSubmitHelpPage) || false;
        this.shouldShowSubmitHelpInNewTab = (this.navModuleConfig && this.navModuleConfig.shouldShowSubmitHelpInNewTab) || false;
        this.myProfilePath = (this.navModuleConfig && this.navModuleConfig.myProfilePath) || 'users/my-profile';
        this.logoUrl = (this.navModuleConfig && this.navModuleConfig.logoUrl) || `${this.environmentService.config.imgPath}logo-white.png`;
        this.fullLogoUrl = (this.navModuleConfig && this.navModuleConfig.fullLogoUrl) || `${this.environmentService.config.imgPath}logo.png`;
        this.appName = `${this.environmentService.config.appName}`;
        this.sidebarCollapsed = new BehaviorSubject(false);
        this.showNav = new BehaviorSubject(true);
        this.showFooter = new BehaviorSubject(true);
        this.customHeaderHtml = new BehaviorSubject(null);
        this.customUserDetailsHtml = new BehaviorSubject(null);
        this.footerHtml = new BehaviorSubject(null);
        this.showSubmitHelpButton = this.navModuleConfig && typeof this.navModuleConfig.showSubmitHelpButton !== 'undefined' ? this.navModuleConfig.showSubmitHelpButton : true;
        this.showNewTabButton = this.navModuleConfig && typeof this.navModuleConfig.showNewTabButton !== 'undefined' ? this.navModuleConfig.showNewTabButton : false;
        this.hasKeyboardShortcutsModule = this.navModuleConfig && typeof this.navModuleConfig.hasKeyboardShortcutsModule !== 'undefined'
            ? this.navModuleConfig.hasKeyboardShortcutsModule
            : false;
        this.showKeyboardShortcutsButton = this.navModuleConfig && typeof this.navModuleConfig.showKeyboardShortcutsButton !== 'undefined'
            ? this.navModuleConfig.showKeyboardShortcutsButton
            : this.hasKeyboardShortcutsModule;
        this.siteName = this.navModuleConfig ? this.navModuleConfig.siteName : null;
        this.subject = new BehaviorSubject(state);
        this.store = this.subject.asObservable().pipe(distinctUntilChanged());
        if (this.hasKeyboardShortcutsModule) {
            this.keyboardShortcutHelpWindowService = this.injector.get(KeyboardShortcutHelpWindowService);
        }
        // setting footer html to initial value
        const footerHtml = navModuleConfig && navModuleConfig.footerHtml ? navModuleConfig.footerHtml : 'useDefaultMilesFooter';
        this.footerHtml.next(footerHtml);
    }
    select(name) {
        return this.store.pipe(pluck(name));
    }
    updateNav(navbar) {
        const value = this.subject.value;
        this.subject.next(value);
    }
    setSidebarCollapsed(value) {
        this.sidebarCollapsed.next(value);
    }
    toggleSidebarCollapsed() {
        this.sidebarCollapsed.next(!this.sidebarCollapsed.getValue());
    }
    setShowNav(value) {
        this.showNav.next(value);
    }
    submitHelpRequest() {
        const currentUser = this.authService.currentUser.getValue();
        const data = {
            appName: this.appName,
            url: window.location.href,
            userEmail: currentUser.Email || 'info@4miles.com',
            userName: currentUser.Name,
        };
        return this.http.post(`${this.submitHelpUrl}/api/v1/submit-help/submit-request`, data);
    }
}
NavService.ɵfac = function NavService_Factory(t) { return new (t || NavService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.EnvironmentService), ɵngcc0.ɵɵinject(ɵngcc3.AuthService), ɵngcc0.ɵɵinject(NavModuleConfigToken, 8), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
NavService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NavService, factory: NavService.ɵfac });
NavService.ctorParameters = () => [
    { type: HttpClient },
    { type: EnvironmentService },
    { type: AuthService },
    { type: undefined, decorators: [{ type: Inject, args: [NavModuleConfigToken,] }, { type: Optional }] },
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.EnvironmentService }, { type: ɵngcc3.AuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [NavModuleConfigToken]
            }, {
                type: Optional
            }] }, { type: ɵngcc0.Injector }]; }, null); })();

class Navbar {
}
class NavHeaderComponent {
    constructor(injector) {
        this.subscriptions = new Subscription();
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        this.logoUrl = this.navService.logoUrl;
        this.fullLogoUrl = this.navService.fullLogoUrl;
        this.appName = this.navService.appName;
        this.showNav = this.navService.showNav.getValue();
        this.subscriptions.add(this.navService.showNav.subscribe((showNav) => {
            this.showNav = showNav;
        }));
        this.customHeaderHtml = this.navService.customHeaderHtml.getValue();
        this.subscriptions.add(this.navService.customHeaderHtml.subscribe((headerHtml) => {
            this.customHeaderHtml = headerHtml;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    toggleSidebarCollapse() {
        this.navService.updateNav(this.navBar);
        this.navService.toggleSidebarCollapsed();
    }
}
NavHeaderComponent.ɵfac = function NavHeaderComponent_Factory(t) { return new (t || NavHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
NavHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavHeaderComponent, selectors: [["app-nav-header"]], decls: 78, vars: 12, consts: [[1, "main-header", "hidden-sm", "hidden-xs", 3, "hidden"], [1, "logo", "pointer", 3, "routerLink"], [1, "logo-mini"], ["alt", "minilogo", 1, "logo-img", 3, "src"], [1, "logo-lg"], ["alt", "logo", 1, "visible-md-block", "visible-lg-block", 3, "src"], ["role", "navigation", 1, "navbar", "navbar-static-top"], [1, "navbar-custom-menu"], [1, "nav", "navbar-nav", "custom-header-area", "visible-lg-block", 3, "innerHtml"], [1, "main-header", "hidden-md", "hidden-lg", "hidden-xl", 3, "hidden"], ["role", "navigation", 1, "navbar", "navbar-static-top", "mobile-navbar"], ["data-toggle", "offcanvas", "role", "button", 1, "sidebar-toggle", 3, "click"], [1, "sr-only"], [1, "pointer", 3, "routerLink"], [1, "logo", "mobile-app-name"]], template: function NavHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtext(1, "\n        ");
        ɵngcc0.ɵɵelementStart(2, "header", 0);
        ɵngcc0.ɵɵtext(3, "\n            ");
        ɵngcc0.ɵɵtext(4, "\n            ");
        ɵngcc0.ɵɵelementStart(5, "a", 1);
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵtext(7, "\n                ");
        ɵngcc0.ɵɵelementStart(8, "span", 2);
        ɵngcc0.ɵɵtext(9, "\n                    ");
        ɵngcc0.ɵɵelement(10, "img", 3);
        ɵngcc0.ɵɵtext(11, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵtext(13, "\n                ");
        ɵngcc0.ɵɵelementStart(14, "div", 4);
        ɵngcc0.ɵɵtext(15, "\n                    ");
        ɵngcc0.ɵɵelement(16, "img", 5);
        ɵngcc0.ɵɵtext(17, "\n                    ");
        ɵngcc0.ɵɵelementStart(18, "b");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(22, "\n\n            ");
        ɵngcc0.ɵɵtext(23, "\n            ");
        ɵngcc0.ɵɵelementStart(24, "nav", 6);
        ɵngcc0.ɵɵtext(25, "\n                ");
        ɵngcc0.ɵɵtext(26, "\n                ");
        ɵngcc0.ɵɵelementStart(27, "div", 7);
        ɵngcc0.ɵɵtext(28, "\n                    ");
        ɵngcc0.ɵɵelement(29, "div", 8);
        ɵngcc0.ɵɵtext(30, "\n                    ");
        ɵngcc0.ɵɵelement(31, "header-current-user-details");
        ɵngcc0.ɵɵtext(32, "\n                    ");
        ɵngcc0.ɵɵelement(33, "header-new-tab");
        ɵngcc0.ɵɵtext(34, "\n                    ");
        ɵngcc0.ɵɵelement(35, "header-shortcut-help");
        ɵngcc0.ɵɵtext(36, "\n                    ");
        ɵngcc0.ɵɵelement(37, "header-submit-help");
        ɵngcc0.ɵɵtext(38, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(39, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(40, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(41, "\n        ");
        ɵngcc0.ɵɵtext(42, "\n        ");
        ɵngcc0.ɵɵelementStart(43, "header", 9);
        ɵngcc0.ɵɵtext(44, "\n            ");
        ɵngcc0.ɵɵelementStart(45, "nav", 10);
        ɵngcc0.ɵɵtext(46, "\n                ");
        ɵngcc0.ɵɵelementStart(47, "div", 11);
        ɵngcc0.ɵɵlistener("click", function NavHeaderComponent_Template_div_click_47_listener() { return ctx.toggleSidebarCollapse(); });
        ɵngcc0.ɵɵtext(48, "\n                    ");
        ɵngcc0.ɵɵelementStart(49, "span", 12);
        ɵngcc0.ɵɵtext(50, "Toggle navigation");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(51, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(52, "\n                ");
        ɵngcc0.ɵɵelementStart(53, "a", 13);
        ɵngcc0.ɵɵtext(54, "\n                    ");
        ɵngcc0.ɵɵelementStart(55, "span", 14);
        ɵngcc0.ɵɵtext(56, "\n                        ");
        ɵngcc0.ɵɵelementStart(57, "b");
        ɵngcc0.ɵɵtext(58);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(59, "\n                    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(60, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(61, "\n\n                ");
        ɵngcc0.ɵɵtext(62, "\n                ");
        ɵngcc0.ɵɵelementStart(63, "div", 7);
        ɵngcc0.ɵɵtext(64, "\n                    ");
        ɵngcc0.ɵɵelement(65, "div", 8);
        ɵngcc0.ɵɵtext(66, "\n                    ");
        ɵngcc0.ɵɵelement(67, "header-current-user-details");
        ɵngcc0.ɵɵtext(68, "\n                    ");
        ɵngcc0.ɵɵelement(69, "header-new-tab");
        ɵngcc0.ɵɵtext(70, "\n                    ");
        ɵngcc0.ɵɵelement(71, "header-shortcut-help");
        ɵngcc0.ɵɵtext(72, "\n                    ");
        ɵngcc0.ɵɵelement(73, "header-submit-help");
        ɵngcc0.ɵɵtext(74, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(75, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(76, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(77, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showNav);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(10, _c0));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("src", ctx.logoUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("src", ctx.fullLogoUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.appName);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.customHeaderHtml, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(14);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showNav);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(11, _c0));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.appName);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.customHeaderHtml, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: function () { return [ɵngcc4.RouterLinkWithHref, ɵngcc5.ɵm, HeaderCurrentUserDetailsComponent, HeaderNewTabComponent, HeaderShortcutHelpComponent, HeaderSubmitHelpComponent]; }, styles: [".main-header[_ngcontent-%COMP%] {\n                position: fixed;\n                top: 0;\n                width: 100vw;\n            }\n            .navbar-custom-menu[_ngcontent-%COMP%] {\n                margin-right: 20px;\n            }\n            .custom-header-area[_ngcontent-%COMP%] {\n                width: 345px;\n                padding-top: 15px;\n                color: #fff;\n            }\n            .mobile-app-name[_ngcontent-%COMP%] {\n                width: auto;\n                float: unset;\n                display: inherit;\n                padding: 0;\n            }\n            .main-header[_ngcontent-%COMP%]    > .navbar[_ngcontent-%COMP%] {\n                margin-left: 500px;\n            }\n            .main-header[_ngcontent-%COMP%]    > .navbar.mobile-navbar[_ngcontent-%COMP%] {\n                margin-left: 0;\n            }\n            .main-header[_ngcontent-%COMP%]    > .navbar.mobile-navbar[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n                text-decoration-line: none;\n            }\n            .main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%] {\n                width: 500px;\n            }", _c4] });
NavHeaderComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-nav-header',
                template: `
        <!-- header for medium size and up -->
        <header class="main-header hidden-sm hidden-xs" [hidden]="!showNav">
            <!-- Logo -->
            <a [routerLink]="['/']" class="logo pointer">
                <!-- mini logo for sidebar mini 50x50 pixels -->
                <span class="logo-mini">
                    <img [src]="logoUrl" alt="minilogo" class="logo-img" />
                </span>
                <!-- logo for regular state and mobile devices -->
                <div class="logo-lg">
                    <img class="visible-md-block visible-lg-block" [src]="fullLogoUrl" alt="logo" />
                    <b>{{ appName }}</b>
                </div>
            </a>

            <!-- Header Navbar: style can be found in header.less -->
            <nav class="navbar navbar-static-top" role="navigation">
                <!-- Navbar Right Menu -->
                <div class="navbar-custom-menu">
                    <div class="nav navbar-nav custom-header-area visible-lg-block" [innerHtml]="customHeaderHtml"></div>
                    <header-current-user-details></header-current-user-details>
                    <header-new-tab></header-new-tab>
                    <header-shortcut-help></header-shortcut-help>
                    <header-submit-help></header-submit-help>
                </div>
            </nav>
        </header>
        <!-- header for small size and down -->
        <header class="main-header hidden-md hidden-lg hidden-xl" [hidden]="!showNav">
            <nav class="navbar navbar-static-top mobile-navbar" role="navigation">
                <div data-toggle="offcanvas" class="sidebar-toggle" role="button" (click)="toggleSidebarCollapse()">
                    <span class="sr-only">Toggle navigation</span>
                </div>
                <a [routerLink]="['/']" class="pointer">
                    <span class="logo mobile-app-name">
                        <b>{{ appName }}</b>
                    </span>
                </a>

                <!-- Navbar Right Menu -->
                <div class="navbar-custom-menu">
                    <div class="nav navbar-nav custom-header-area visible-lg-block" [innerHtml]="customHeaderHtml"></div>
                    <header-current-user-details></header-current-user-details>
                    <header-new-tab></header-new-tab>
                    <header-shortcut-help></header-shortcut-help>
                    <header-submit-help></header-submit-help>
                </div>
            </nav>
        </header>
    `,
                styles: [`
            .main-header {
                position: fixed;
                top: 0;
                width: 100vw;
            }
            .navbar-custom-menu {
                margin-right: 20px;
            }
            .custom-header-area {
                width: 345px;
                padding-top: 15px;
                color: #fff;
            }
            .mobile-app-name {
                width: auto;
                float: unset;
                display: inherit;
                padding: 0;
            }
            .main-header > .navbar {
                margin-left: 500px;
            }
            .main-header > .navbar.mobile-navbar {
                margin-left: 0;
            }
            .main-header > .navbar.mobile-navbar > a {
                text-decoration-line: none;
            }
            .main-header .logo {
                width: 500px;
            }
        `, ".navbar-nav.nav-header-button{color:#fff;cursor:pointer;max-height:50px;min-width:30px;text-align:center}.navbar-nav.nav-header-button a{color:#fff}.navbar-nav.nav-header-button i{height:50px;line-height:50px;white-space:nowrap}.navbar-nav.nav-header-button:hover{background:rgba(0,0,0,.15)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

function getProfileImgPathFromCurrentUser(currentUser, environmentService) {
    if (common.isNullOrWhitespace(currentUser.ProfileImagePath) || currentUser.ProfileImagePath === 'default.png') {
        return `${environmentService.config.assetsPath}noimage.png`;
    }
    if (isURL(currentUser.ProfileImagePath)) {
        return currentUser.ProfileImagePath;
    }
    const profilePath = environmentService.config.imgUploadPath || environmentService.config.imgPath;
    return profilePath + currentUser.ProfileImagePath;
}
function isURL(str) {
    let pattern = new RegExp('https?://(www.)?[-a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
    return pattern.test(str);
}

class HeaderCurrentUserDetailsComponent {
    constructor(injector) {
        this.subscriptions = new Subscription();
        this.navService = injector.get(NavService);
        this.authService = injector.get(AuthService);
        this.environmentService = injector.get(EnvironmentService);
    }
    ngOnInit() {
        this.setCurrentUserVariables(this.authService.currentUser.getValue());
        this.subscriptions.add(this.authService.currentUser.subscribe((currentUser) => this.setCurrentUserVariables(currentUser)));
        this.customUserDetailsHtml = this.navService.customUserDetailsHtml.getValue();
        this.subscriptions.add(this.navService.customUserDetailsHtml.subscribe((userDetailsHtml) => {
            this.customUserDetailsHtml = userDetailsHtml;
        }));
    }
    setCurrentUserVariables(currentUser) {
        this.userName = currentUser.Name || 'User';
        this.userImageUrl = getProfileImgPathFromCurrentUser(currentUser, this.environmentService);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    logout() {
        this.authService.logout();
    }
}
HeaderCurrentUserDetailsComponent.ɵfac = function HeaderCurrentUserDetailsComponent_Factory(t) { return new (t || HeaderCurrentUserDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
HeaderCurrentUserDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderCurrentUserDetailsComponent, selectors: [["header-current-user-details"]], contentQueries: function HeaderCurrentUserDetailsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c1, true, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c2, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownToggleTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownMenuTemplate = _t.first);
    } }, decls: 25, vars: 14, consts: [[1, "nav", "navbar-nav"], ["ngbDropdown", "", 1, "dropdown", "user", "user-menu"], ["ngbDropdownToggle", "", "data-toggle", "dropdown", 1, "dropdown-toggle", "user-dropdown-toggle"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"], ["ngbDropdownMenu", "", "display", "dynamic", 1, "dropdown-menu", "''"], [1, "user-header"], ["aria-hidden", "true", 1, "fa", "fa-user"], [1, "hidden-sm", "hidden-xs"], ["alt", "Profile Image", 1, "img-circle", 3, "src"], ["class", "custom-user-details", 3, "innerHtml", 4, "ngIf"], [1, "btn", "btn-warning", "btn-flat", "sign-out-button", 3, "click"], [1, "custom-user-details", 3, "innerHtml"]], template: function HeaderCurrentUserDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "ul", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵtext(3, "\n            ");
        ɵngcc0.ɵɵelementStart(4, "li", 1);
        ɵngcc0.ɵɵtext(5, "\n                ");
        ɵngcc0.ɵɵelementStart(6, "a", 2);
        ɵngcc0.ɵɵtext(7, "\n                    ");
        ɵngcc0.ɵɵtemplate(8, HeaderCurrentUserDetailsComponent_ng_container_8_Template, 2, 0, "ng-container", 3);
        ɵngcc0.ɵɵtext(9, "\n                    ");
        ɵngcc0.ɵɵtemplate(10, HeaderCurrentUserDetailsComponent_span_10_Template, 7, 1, "span", 4);
        ɵngcc0.ɵɵtext(11, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n                ");
        ɵngcc0.ɵɵelementStart(13, "ul", 5);
        ɵngcc0.ɵɵtext(14, "\n                    ");
        ɵngcc0.ɵɵelementStart(15, "li", 6);
        ɵngcc0.ɵɵtext(16, "\n                        ");
        ɵngcc0.ɵɵtemplate(17, HeaderCurrentUserDetailsComponent_ng_container_17_Template, 2, 0, "ng-container", 3);
        ɵngcc0.ɵɵtext(18, "\n                        ");
        ɵngcc0.ɵɵtemplate(19, HeaderCurrentUserDetailsComponent_ng_container_19_Template, 13, 3, "ng-container", 4);
        ɵngcc0.ɵɵtext(20, "\n                    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(22, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(23, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(24, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.dropdownToggleTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(6, _c3, ctx.userName, ctx.userImageUrl, ctx.logout.bind(ctx)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.dropdownToggleTemplate);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.dropdownMenuTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(10, _c3, ctx.userName, ctx.userImageUrl, ctx.logout.bind(ctx)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.dropdownMenuTemplate);
    } }, directives: [ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc6.NgTemplateOutlet, ɵngcc6.NgIf, ɵngcc5.NgbDropdownMenu], styles: [".navbar-nav[_ngcontent-%COMP%]   .user-menu[_ngcontent-%COMP%] {\n                cursor: pointer;\n            }\n            .navbar-nav[_ngcontent-%COMP%]    > .user-menu[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%]    > li.user-header[_ngcontent-%COMP%] {\n                height: inherit;\n            }\n            .navbar-nav[_ngcontent-%COMP%]    > .user-menu[_ngcontent-%COMP%]    > .user-dropdown-toggle[_ngcontent-%COMP%] {\n                padding-left: 8px;\n                padding-right: 8px;\n            }\n            .sign-out-button[_ngcontent-%COMP%] {\n                margin-bottom: 15px;\n            }\n            .navbar-nav[_ngcontent-%COMP%]    > .user-menu[_ngcontent-%COMP%]    > .dropdown-menu[_ngcontent-%COMP%]    > li.user-header[_ngcontent-%COMP%]    > p.custom-user-details[_ngcontent-%COMP%] {\n                z-index: 5;\n                color: rgba(255, 255, 255, 0.8);\n                font-size: 14px;\n                margin: 0;\n                margin-bottom: 10px;\n            }", _c4] });
HeaderCurrentUserDetailsComponent.ctorParameters = () => [
    { type: Injector }
];
HeaderCurrentUserDetailsComponent.propDecorators = {
    dropdownToggleTemplate: [{ type: ContentChild, args: ['dropdownToggleTemplate', { read: TemplateRef },] }],
    dropdownMenuTemplate: [{ type: ContentChild, args: ['dropdownMenuTemplate', { read: TemplateRef },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderCurrentUserDetailsComponent, [{
        type: Component,
        args: [{
                selector: `header-current-user-details`,
                template: `
        <ul class="nav navbar-nav">
            <!-- User Account: style can be found in dropdown.less -->
            <li ngbDropdown class="dropdown user user-menu">
                <a ngbDropdownToggle class="dropdown-toggle user-dropdown-toggle" data-toggle="dropdown">
                    <ng-container
                        *ngTemplateOutlet="
                            dropdownToggleTemplate;
                            context: { userName: this.userName, userImageUrl: this.userImageUrl, logout: this.logout.bind(this) }
                        "
                    >
                    </ng-container>
                    <span *ngIf="!dropdownToggleTemplate">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <b class="hidden-sm hidden-xs">{{ userName }}</b>
                    </span>
                </a>
                <ul ngbDropdownMenu class="dropdown-menu ''" display="dynamic">
                    <li class="user-header">
                        <ng-container
                            *ngTemplateOutlet="
                                dropdownMenuTemplate;
                                context: { userName: this.userName, userImageUrl: this.userImageUrl, logout: this.logout.bind(this) }
                            "
                        >
                        </ng-container>
                        <ng-container *ngIf="!dropdownMenuTemplate">
                            <!-- User image -->
                            <img [src]="userImageUrl" class="img-circle" alt="Profile Image" />
                            <p>
                                {{ userName }}
                            </p>
                            <p *ngIf="customUserDetailsHtml" class="custom-user-details" [innerHtml]="customUserDetailsHtml"></p>
                            <button class="btn btn-warning btn-flat sign-out-button" (click)="logout()">Sign out</button>
                        </ng-container>
                    </li>
                </ul>
            </li>
        </ul>
    `,
                styles: [`
            .navbar-nav .user-menu {
                cursor: pointer;
            }
            .navbar-nav > .user-menu > .dropdown-menu > li.user-header {
                height: inherit;
            }
            .navbar-nav > .user-menu > .user-dropdown-toggle {
                padding-left: 8px;
                padding-right: 8px;
            }
            .sign-out-button {
                margin-bottom: 15px;
            }
            .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p.custom-user-details {
                z-index: 5;
                color: rgba(255, 255, 255, 0.8);
                font-size: 14px;
                margin: 0;
                margin-bottom: 10px;
            }
        `, ".navbar-nav.nav-header-button{color:#fff;cursor:pointer;max-height:50px;min-width:30px;text-align:center}.navbar-nav.nav-header-button a{color:#fff}.navbar-nav.nav-header-button i{height:50px;line-height:50px;white-space:nowrap}.navbar-nav.nav-header-button:hover{background:rgba(0,0,0,.15)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { dropdownToggleTemplate: [{
            type: ContentChild,
            args: ['dropdownToggleTemplate', { read: TemplateRef }]
        }], dropdownMenuTemplate: [{
            type: ContentChild,
            args: ['dropdownMenuTemplate', { read: TemplateRef }]
        }] }); })();

class HeaderNewTabComponent {
    constructor(injector) {
        this.navService = injector.get(NavService);
    }
    get showNewTabButton() {
        return this.navService.showNewTabButton;
    }
    openInNewTab() {
        window.open(window.location.href);
    }
}
HeaderNewTabComponent.ɵfac = function HeaderNewTabComponent_Factory(t) { return new (t || HeaderNewTabComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
HeaderNewTabComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderNewTabComponent, selectors: [["header-new-tab"]], contentQueries: function HeaderNewTabComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, decls: 5, vars: 6, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "nav navbar-nav nav-header-button", "title", "new tab", 3, "click", 4, "ngIf"], ["title", "new tab", 1, "nav", "navbar-nav", "nav-header-button", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-external-link"]], template: function HeaderNewTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, HeaderNewTabComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, HeaderNewTabComponent_div_3_Template, 7, 0, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c5, ctx.openInNewTab.bind(ctx), ctx.showNewTabButton));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNewTabButton && !ctx.templateRef);
    } }, directives: [ɵngcc6.NgTemplateOutlet, ɵngcc6.NgIf], styles: [_c4] });
HeaderNewTabComponent.ctorParameters = () => [
    { type: Injector }
];
HeaderNewTabComponent.propDecorators = {
    templateRef: [{ type: ContentChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderNewTabComponent, [{
        type: Component,
        args: [{
                selector: `header-new-tab`,
                template: `
        <ng-container
            *ngTemplateOutlet="templateRef; context: { openInNewTab: this.openInNewTab.bind(this), showNewTabButton: this.showNewTabButton }"
        >
        </ng-container>
        <div *ngIf="showNewTabButton && !templateRef" class="nav navbar-nav nav-header-button" title="new tab" (click)="openInNewTab()">
            <a>
                <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
        </div>
    `,
                styles: [".navbar-nav.nav-header-button{color:#fff;cursor:pointer;max-height:50px;min-width:30px;text-align:center}.navbar-nav.nav-header-button a{color:#fff}.navbar-nav.nav-header-button i{height:50px;line-height:50px;white-space:nowrap}.navbar-nav.nav-header-button:hover{background:rgba(0,0,0,.15)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { templateRef: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class HeaderShortcutHelpComponent {
    constructor(injector) {
        this.navService = injector.get(NavService);
    }
    get showShortcutHelpButton() {
        return this.navService.showKeyboardShortcutsButton && this.navService.hasKeyboardShortcutsModule;
    }
    openShortcutHelp() {
        this.navService.keyboardShortcutHelpWindowService.showHelpWindow();
    }
}
HeaderShortcutHelpComponent.ɵfac = function HeaderShortcutHelpComponent_Factory(t) { return new (t || HeaderShortcutHelpComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
HeaderShortcutHelpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderShortcutHelpComponent, selectors: [["header-shortcut-help"]], contentQueries: function HeaderShortcutHelpComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, decls: 5, vars: 6, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "nav navbar-nav nav-header-button shortcut-help", "title", "Keyboard Shortcuts", 3, "click", 4, "ngIf"], ["title", "Keyboard Shortcuts", 1, "nav", "navbar-nav", "nav-header-button", "shortcut-help", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-info-circle"], [1, "hidden-xs", "hidden-sm", "help-text"]], template: function HeaderShortcutHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, HeaderShortcutHelpComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, HeaderShortcutHelpComponent_div_3_Template, 7, 0, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c6, ctx.openShortcutHelp.bind(ctx), ctx.showShortcutHelpButton));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showShortcutHelpButton && !ctx.templateRef);
    } }, directives: [ɵngcc6.NgTemplateOutlet, ɵngcc6.NgIf], styles: [".shortcut-help[_ngcontent-%COMP%] {\n                cursor: pointer;\n                padding-left: 8px;\n                padding-right: 8px;\n            }\n            .shortcut-help[_ngcontent-%COMP%]   .help-text[_ngcontent-%COMP%] {\n                font-size: 11px;\n                vertical-align: text-bottom;\n            }", _c4] });
HeaderShortcutHelpComponent.ctorParameters = () => [
    { type: Injector }
];
HeaderShortcutHelpComponent.propDecorators = {
    templateRef: [{ type: ContentChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderShortcutHelpComponent, [{
        type: Component,
        args: [{
                selector: `header-shortcut-help`,
                template: `
        <ng-container
            *ngTemplateOutlet="
                templateRef;
                context: { openShortcutHelp: this.openShortcutHelp.bind(this), showShortcutHelpButton: this.showShortcutHelpButton }
            "
        >
        </ng-container>
        <div
            *ngIf="showShortcutHelpButton && !templateRef"
            class="nav navbar-nav nav-header-button shortcut-help"
            title="Keyboard Shortcuts"
            (click)="openShortcutHelp()"
        >
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <span class="hidden-xs hidden-sm help-text"> Shortcuts </span>
        </div>
    `,
                styles: [`
            .shortcut-help {
                cursor: pointer;
                padding-left: 8px;
                padding-right: 8px;
            }
            .shortcut-help .help-text {
                font-size: 11px;
                vertical-align: text-bottom;
            }
        `, ".navbar-nav.nav-header-button{color:#fff;cursor:pointer;max-height:50px;min-width:30px;text-align:center}.navbar-nav.nav-header-button a{color:#fff}.navbar-nav.nav-header-button i{height:50px;line-height:50px;white-space:nowrap}.navbar-nav.nav-header-button:hover{background:rgba(0,0,0,.15)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { templateRef: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class HeaderSubmitHelpComponent {
    constructor(injector) {
        this.navService = injector.get(NavService);
        this.router = injector.get(Router);
    }
    get showSubmitHelpButton() {
        return this.navService.showSubmitHelpButton;
    }
    submitHelp() {
        const submitHelpUrl = this.navService.submitHelpUrl;
        let submitHelpWindow;
        if (!this.navService.isCustomSubmitHelpPage) {
            submitHelpWindow = window.open();
            submitHelpWindow.document.write('loading...');
            this.navService.submitHelpRequest().subscribe((requestId) => {
                submitHelpWindow.location.href = `${submitHelpUrl}/#/submit-request/${requestId}`;
            }, () => {
                submitHelpWindow.location.href = `${submitHelpUrl}/#/submit-request`;
            });
        }
        else {
            if (this.navService.shouldShowSubmitHelpInNewTab) {
                submitHelpWindow = window.open();
                submitHelpWindow.location.href = `${submitHelpUrl}`;
            }
            else {
                this.router.navigateByUrl(submitHelpUrl);
            }
        }
    }
}
HeaderSubmitHelpComponent.ɵfac = function HeaderSubmitHelpComponent_Factory(t) { return new (t || HeaderSubmitHelpComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
HeaderSubmitHelpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderSubmitHelpComponent, selectors: [["header-submit-help"]], contentQueries: function HeaderSubmitHelpComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, decls: 5, vars: 5, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "nav navbar-nav submit-help", "title", "Submit Help Request", 3, "click", 4, "ngIf"], ["title", "Submit Help Request", 1, "nav", "navbar-nav", "submit-help", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-question-circle"], [1, "hidden-xs", "hidden-sm", "help-text"]], template: function HeaderSubmitHelpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, HeaderSubmitHelpComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, HeaderSubmitHelpComponent_div_3_Template, 7, 0, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c7, ctx.submitHelp.bind(ctx)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSubmitHelpButton && !ctx.templateRef);
    } }, directives: [ɵngcc6.NgTemplateOutlet, ɵngcc6.NgIf], styles: [".submit-help[_ngcontent-%COMP%] {\n                cursor: pointer;\n                padding-left: 8px;\n                padding-right: 8px;\n            }\n            .submit-help[_ngcontent-%COMP%]   .help-text[_ngcontent-%COMP%] {\n                font-size: 11px;\n                vertical-align: text-bottom;\n            }"] });
HeaderSubmitHelpComponent.ctorParameters = () => [
    { type: Injector }
];
HeaderSubmitHelpComponent.propDecorators = {
    templateRef: [{ type: ContentChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderSubmitHelpComponent, [{
        type: Component,
        args: [{
                selector: `header-submit-help`,
                template: `
        <ng-container *ngTemplateOutlet="templateRef; context: { submitHelp: this.submitHelp.bind(this) }"> </ng-container>
        <div *ngIf="showSubmitHelpButton && !templateRef" class="nav navbar-nav submit-help" title="Submit Help Request" (click)="submitHelp()">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
            <span class="hidden-xs hidden-sm help-text"> Help </span>
        </div>
    `,
                styles: [`
            .submit-help {
                cursor: pointer;
                padding-left: 8px;
                padding-right: 8px;
            }
            .submit-help .help-text {
                font-size: 11px;
                vertical-align: text-bottom;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { templateRef: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class NavSidebarComponent {
    constructor() {
        this.setMaxHeight(window.innerHeight);
    }
    onResize(event) {
        this.setMaxHeight(event.target.innerHeight);
    }
    setMaxHeight(innerHeight) {
        this.navTreeMaxHeight = innerHeight - 115 + 'px';
    }
}
NavSidebarComponent.ɵfac = function NavSidebarComponent_Factory(t) { return new (t || NavSidebarComponent)(); };
NavSidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavSidebarComponent, selectors: [["app-nav-sidebar"]], hostBindings: function NavSidebarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NavSidebarComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, decls: 14, vars: 2, consts: [[1, "nav-sidebar-section"], [1, "main-sidebar", "sidebar"], [1, "nav-panel-section"]], template: function NavSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n            ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n                ");
        ɵngcc0.ɵɵelement(5, "sidebar-current-user-details");
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵtext(8, "\n                    ");
        ɵngcc0.ɵɵelement(9, "sidebar-content-section");
        ɵngcc0.ɵɵtext(10, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(11, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(13, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵstyleProp("max-height", ctx.navTreeMaxHeight ? ctx.navTreeMaxHeight : null);
    } }, directives: function () { return [SidebarCurrentUserDetailsComponent, SidebarContentSectionComponent]; }, styles: [".nav-sidebar-section[_ngcontent-%COMP%] {\n                overflow: auto;\n                flex-grow: 1;\n                display: flex;\n                height: 0px;\n            }\n            .main-sidebar[_ngcontent-%COMP%] {\n                overflow: hidden;\n            }\n            .nav-panel-section[_ngcontent-%COMP%] {\n                overflow: auto;\n            }\n            .nav-panel-section[_ngcontent-%COMP%]::-webkit-scrollbar {\n                width: 5px;\n                background-color: #f5f5f5;\n            }\n            .nav-panel-section[_ngcontent-%COMP%]::-webkit-scrollbar-thumb {\n                background-color: #aaa;\n            }"] });
NavSidebarComponent.ctorParameters = () => [];
NavSidebarComponent.propDecorators = {
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'app-nav-sidebar',
                template: `
        <div class="nav-sidebar-section">
            <div class="main-sidebar sidebar">
                <sidebar-current-user-details></sidebar-current-user-details>
                <div class="nav-panel-section" [style.max-height]="navTreeMaxHeight ? navTreeMaxHeight : null">
                    <sidebar-content-section></sidebar-content-section>
                </div>
            </div>
        </div>
    `,
                styles: [`
            .nav-sidebar-section {
                overflow: auto;
                flex-grow: 1;
                display: flex;
                height: 0px;
            }
            .main-sidebar {
                overflow: hidden;
            }
            .nav-panel-section {
                overflow: auto;
            }
            .nav-panel-section::-webkit-scrollbar {
                width: 5px;
                background-color: #f5f5f5;
            }
            .nav-panel-section::-webkit-scrollbar-thumb {
                background-color: #aaa;
            }
        `]
            }]
    }], function () { return []; }, { onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class NavMenuItemComponent {
    constructor(injector) {
        this.router = injector.get(Router);
        this.claimsService = injector.get(ClaimsService);
        this.navService = injector.get(NavService);
        this.accessRequestsModuleConfigService = injector.get(AccessRequestsModuleConfigService);
    }
    get hasKeyboardShortcutsModule() {
        return this.navService.hasKeyboardShortcutsModule;
    }
    ngOnInit() {
        this.accessRequestsModuleConfigService.accessRequestsEnabled
            .pipe(take(1))
            .subscribe((accessRequestsEnabled) => (this.accessRequestsEnabled = accessRequestsEnabled));
    }
    get ShowSettings() {
        var _a;
        if (!((_a = this.rowItem.settingsLink) === null || _a === void 0 ? void 0 : _a.link)) {
            return false;
        }
        if (this.accessRequestsEnabled) {
            return true;
        }
        if (this.rowItem.settingsClaimType && this.rowItem.settingsClaimValues) {
            return this.claimsService.hasClaim(this.rowItem.settingsClaimType, this.rowItem.settingsClaimValues);
        }
        return true;
    }
    get ShowAdd() {
        var _a;
        if (!((_a = this.rowItem.addLink) === null || _a === void 0 ? void 0 : _a.link)) {
            return false;
        }
        if (this.accessRequestsEnabled) {
            return true;
        }
        if (this.rowItem.addClaimType && this.rowItem.addClaimValues) {
            return this.claimsService.hasClaim(this.rowItem.addClaimType, this.rowItem.addClaimValues);
        }
        return true;
    }
    get ShowMe() {
        if (this.accessRequestsEnabled) {
            return true;
        }
        if (this.rowItem.claimType && this.rowItem.claimValues && this.rowItem.claimValues.length > 0) {
            return this.claimsService.hasClaim(this.rowItem.claimType, this.rowItem.claimValues);
        }
        return true;
    }
    get isParentRow() {
        return this.rowItem && this.rowItem.children ? true : false;
    }
    toggleExpand() {
        if (!this.isParentRow) {
            return;
        }
        const parentRowItem = this.rowItem;
        if (parentRowItem.canToggleExpand) {
            parentRowItem.expanded = !parentRowItem.expanded;
        }
    }
    stopProp($event) {
        $event.stopPropagation();
        if (this.setting) {
            this.setting.nativeElement.blur();
        }
    }
}
NavMenuItemComponent.ɵfac = function NavMenuItemComponent_Factory(t) { return new (t || NavMenuItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
NavMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavMenuItemComponent, selectors: [["app-nav-menu-item"]], viewQuery: function NavMenuItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.setting = _t.first);
    } }, inputs: { rowItem: "rowItem" }, decls: 9, vars: 3, consts: [["class", "nav-item", 3, "click", 4, "ngIf"], ["class", "nav-item", 3, "keyboardShortcut", "routerLink", "queryParams", "fragment", 4, "ngIf"], ["class", "nav-item", 3, "routerLink", "queryParams", "fragment", 4, "ngIf"], ["rowItemTemplate", ""], [1, "nav-item", 3, "click"], [4, "ngTemplateOutlet"], [1, "nav-item", 3, "keyboardShortcut", "routerLink", "queryParams", "fragment"], [1, "nav-item", 3, "routerLink", "queryParams", "fragment"], [1, "menu-title", 2, "white-space", "normal"], ["class", "btn btn-nav btn-transparent pull-right", 3, "routerLink", "queryParams", "fragment", "click", 4, "ngIf"], ["class", "btn btn-nav btn-nav-on-hover btn-transparent pull-right", 3, "routerLink", "queryParams", "fragment", "click", 4, "ngIf"], [1, "btn", "btn-nav", "btn-transparent", "pull-right", 3, "routerLink", "queryParams", "fragment", "click"], ["setting", ""], [1, "fa", "fa-fw", "fa-cog"], [1, "btn", "btn-nav", "btn-nav-on-hover", "btn-transparent", "pull-right", 3, "routerLink", "queryParams", "fragment", "click"], [1, "fa", "fa-fw", "fa-plus"]], template: function NavMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NavMenuItemComponent_a_0_Template, 4, 1, "a", 0);
        ɵngcc0.ɵɵtext(1, "\n");
        ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_a_2_Template, 4, 5, "a", 1);
        ɵngcc0.ɵɵtext(3, "\n");
        ɵngcc0.ɵɵtemplate(4, NavMenuItemComponent_a_4_Template, 4, 4, "a", 2);
        ɵngcc0.ɵɵtext(5, "\n");
        ɵngcc0.ɵɵtemplate(6, NavMenuItemComponent_ng_template_6_Template, 10, 8, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtext(8, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.ShowMe && ctx.isParentRow);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ShowMe && !ctx.isParentRow && ctx.hasKeyboardShortcutsModule);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ShowMe && !ctx.isParentRow && !ctx.hasKeyboardShortcutsModule);
    } }, directives: [ɵngcc6.NgIf, ɵngcc6.NgTemplateOutlet, ɵngcc4.RouterLinkWithHref, ɵngcc7.KeyboardShortcutDirective], encapsulation: 2 });
NavMenuItemComponent.ctorParameters = () => [
    { type: Injector }
];
NavMenuItemComponent.propDecorators = {
    setting: [{ type: ViewChild, args: ['setting',] }],
    rowItem: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'app-nav-menu-item',
                template: "<a *ngIf=\"ShowMe && isParentRow\" class=\"nav-item\" (click)=\"toggleExpand()\">\n    <ng-container *ngTemplateOutlet=\"rowItemTemplate\"> </ng-container>\n</a>\n<a\n    *ngIf=\"ShowMe && !isParentRow && hasKeyboardShortcutsModule\"\n    class=\"nav-item\"\n    [keyboardShortcut]=\"rowItem.shortcut\"\n    [routerLink]=\"rowItem.link.link\"\n    [queryParams]=\"rowItem.link.queryParams\"\n    [fragment]=\"rowItem.link.fragment\"\n>\n    <ng-container *ngTemplateOutlet=\"rowItemTemplate\"> </ng-container>\n</a>\n<a\n    *ngIf=\"ShowMe && !isParentRow && !hasKeyboardShortcutsModule\"\n    class=\"nav-item\"\n    [routerLink]=\"rowItem.link.link\"\n    [queryParams]=\"rowItem.link.queryParams\"\n    [fragment]=\"rowItem.link.fragment\"\n>\n    <ng-container *ngTemplateOutlet=\"rowItemTemplate\"> </ng-container>\n</a>\n<ng-template #rowItemTemplate>\n    <div class=\"menu-img {{ rowItem.icon }}\"></div>\n    <span class=\"menu-title\" [class.active]=\"rowItem.link ? router.isActive(rowItem.link.link, true) : null\" style=\"white-space: normal\">\n        {{ rowItem.content }}\n        <a\n            *ngIf=\"ShowSettings\"\n            #setting\n            class=\"btn btn-nav btn-transparent pull-right\"\n            [routerLink]=\"rowItem.settingsLink.link\"\n            [queryParams]=\"rowItem.settingsLink.queryParams\"\n            [fragment]=\"rowItem.settingsLink.fragment\"\n            (click)=\"stopProp($event)\"\n        >\n            <i class=\"fa fa-fw fa-cog\"></i>\n        </a>\n        <a\n            *ngIf=\"ShowAdd\"\n            class=\"btn btn-nav btn-nav-on-hover btn-transparent pull-right\"\n            [routerLink]=\"rowItem.addLink.link\"\n            [queryParams]=\"rowItem.addLink.queryParams\"\n            [fragment]=\"rowItem.addLink.fragment\"\n            (click)=\"stopProp($event)\"\n        >\n            <i class=\"fa fa-fw fa-plus\"></i>\n        </a>\n    </span>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { setting: [{
            type: ViewChild,
            args: ['setting']
        }], rowItem: [{
            type: Input
        }] }); })();

class AppFooterComponent {
    constructor(injector) {
        this.showFooter = true;
        this.subscriptions = new Subscription();
        this.navService = injector.get(NavService);
    }
    ngOnInit() {
        this.subscriptions.add(this.navService.showFooter.subscribe((showFooter) => (this.showFooter = showFooter)));
        this.subscriptions.add(this.navService.footerHtml.subscribe((footerHtml) => (this.footerHtml = footerHtml)));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    goToMilesSite() {
        let milesSiteLink = 'https://www.milestechnologies.com/software-development';
        const siteName = this.navService.siteName;
        if (siteName) {
            milesSiteLink += `?utm_source=client&utm_medium=${siteName}`;
        }
        window.open(milesSiteLink);
    }
}
AppFooterComponent.ɵfac = function AppFooterComponent_Factory(t) { return new (t || AppFooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
AppFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppFooterComponent, selectors: [["app-footer"]], decls: 3, vars: 1, consts: [["class", "main-footer", 4, "ngIf"], [1, "main-footer"], ["class", "container-fluid miles-footer", 3, "innerHtml", 4, "ngIf"], ["class", "container-fluid miles-link", 3, "click", 4, "ngIf"], [1, "container-fluid", "miles-footer", 3, "innerHtml"], [1, "container-fluid", "miles-link", 3, "click"], [1, "miles-blue-text-color"]], template: function AppFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, AppFooterComponent_div_1_Template, 6, 2, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFooter);
    } }, directives: [ɵngcc6.NgIf], styles: [".standard-text-color[_ngcontent-%COMP%] {\n                color: #333;\n            }\n            .miles-blue-text-color[_ngcontent-%COMP%] {\n                color: #004aa0;\n            }\n            .miles-link[_ngcontent-%COMP%] {\n                cursor: pointer;\n            }\n            .miles-footer[_ngcontent-%COMP%] {\n                color: black;\n            }"] });
AppFooterComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppFooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer',
                template: `
        <div *ngIf="showFooter" class="main-footer">
            <div *ngIf="footerHtml !== 'useDefaultMilesFooter'" class="container-fluid miles-footer" [innerHtml]="footerHtml"></div>
            <div *ngIf="footerHtml === 'useDefaultMilesFooter'" class="container-fluid miles-link" (click)="goToMilesSite()">
                <i>powered by</i>&nbsp;<strong class="miles-blue-text-color">MilesTechnologies.com</strong>
            </div>
        </div>
    `,
                styles: [`
            .standard-text-color {
                color: #333;
            }
            .miles-blue-text-color {
                color: #004aa0;
            }
            .miles-link {
                cursor: pointer;
            }
            .miles-footer {
                color: black;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class NavDynamicContentDirective {
    constructor(resolver, container) {
        this.resolver = resolver;
        this.container = container;
    }
    ngOnInit() {
        const factory = this.resolver.resolveComponentFactory(this.componentRef);
        this.component = this.container.createComponent(factory);
        if (typeof this.componentRef === typeof NavContentDynamicHeaderComponent) {
            this.component.instance.header = this.item;
        }
        if (typeof this.componentRef === typeof NavContentDynamicRowComponent) {
            this.component.instance.row = this.item;
        }
    }
}
NavDynamicContentDirective.ɵfac = function NavDynamicContentDirective_Factory(t) { return new (t || NavDynamicContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
NavDynamicContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NavDynamicContentDirective, selectors: [["", "navDynamicContent", ""]], inputs: { componentRef: "componentRef", item: "item" } });
NavDynamicContentDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef }
];
NavDynamicContentDirective.propDecorators = {
    componentRef: [{ type: Input }],
    item: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavDynamicContentDirective, [{
        type: Directive,
        args: [{
                selector: '[navDynamicContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }]; }, { componentRef: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();

class SidebarCurrentUserDetailsComponent {
    constructor(injector) {
        this.subscriptions = new Subscription();
        this.navService = injector.get(NavService);
        this.authService = injector.get(AuthService);
        this.environmentService = injector.get(EnvironmentService);
    }
    ngOnInit() {
        this.myProfilePath = this.navService.myProfilePath;
        this.setCurrentUserVariables(this.authService.currentUser.getValue());
        this.subscriptions.add(this.authService.currentUser.subscribe((currentUser) => this.setCurrentUserVariables(currentUser)));
        this.sidebarCollapsed = this.navService.sidebarCollapsed.getValue();
        this.subscriptions.add(this.navService.sidebarCollapsed.subscribe((sidebarCollapsed) => {
            this.sidebarCollapsed = sidebarCollapsed;
        }));
        this.contextApi = {
            myProfilePath: this.myProfilePath,
            sidebarCollapsed: this.sidebarCollapsed,
            toggleSidebarCollapse: this.toggleSidebarCollapse.bind(this),
            userId: this.userId,
            userImageUrl: this.userImageUrl,
            userName: this.userName,
        };
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    setCurrentUserVariables(currentUser) {
        this.userId = currentUser.Id;
        this.userName = currentUser.Name || 'User';
        this.userImageUrl = getProfileImgPathFromCurrentUser(currentUser, this.environmentService);
    }
    toggleSidebarCollapse() {
        this.navService.toggleSidebarCollapsed();
    }
}
SidebarCurrentUserDetailsComponent.ɵfac = function SidebarCurrentUserDetailsComponent_Factory(t) { return new (t || SidebarCurrentUserDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
SidebarCurrentUserDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarCurrentUserDetailsComponent, selectors: [["sidebar-current-user-details"]], contentQueries: function SidebarCurrentUserDetailsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, decls: 5, vars: 3, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "user-panel", 4, "ngIf"], [1, "user-panel"], [1, "pull-left", "image"], ["alt", "Profile Image", 1, "img-circle", 3, "src"], [1, "pull-left", "info"], [3, "routerLink"], ["role", "button", 1, "fa", "fa-fw", "pull-right", "navbar-toggle", "hidden-md-down", 3, "click"]], template: function SidebarCurrentUserDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, SidebarCurrentUserDetailsComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, SidebarCurrentUserDetailsComponent_div_3_Template, 18, 9, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef)("ngTemplateOutletContext", ctx.contextApi);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.templateRef);
    } }, directives: [ɵngcc6.NgTemplateOutlet, ɵngcc6.NgIf, ɵngcc4.RouterLinkWithHref], styles: [""] });
SidebarCurrentUserDetailsComponent.ctorParameters = () => [
    { type: Injector }
];
SidebarCurrentUserDetailsComponent.propDecorators = {
    templateRef: [{ type: ContentChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarCurrentUserDetailsComponent, [{
        type: Component,
        args: [{
                selector: `sidebar-current-user-details`,
                template: `
        <ng-container *ngTemplateOutlet="templateRef; context: contextApi"> </ng-container>
        <div *ngIf="!templateRef" class="user-panel">
            <div class="pull-left image">
                <img [src]="userImageUrl" class="img-circle" alt="Profile Image" />
            </div>
            <div class="pull-left info">
                <p>{{ userName }}</p>
                <a [routerLink]="[myProfilePath]">Edit my Profile</a>
            </div>
            <i
                role="button"
                (click)="toggleSidebarCollapse()"
                class="fa fa-fw pull-right navbar-toggle hidden-md-down"
                [class.fa-arrow-right]="sidebarCollapsed"
                [class.fa-arrow-left]="!sidebarCollapsed"
            ></i>
        </div>
    `,
                styles: [``]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { templateRef: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class SidebarContentSectionComponent {
    constructor(injector) {
        this.contentItems = [];
        this.subscriptions = new Subscription();
        this.contentSubscriptions = new Subscription();
        this.sidebarService = injector.get(NavSidebarServiceToken);
        this.navService = injector.get(NavService);
        this.claimsService = injector.get(ClaimsService);
        this.accessRequestsModuleConfigService = injector.get(AccessRequestsModuleConfigService);
        this.setContents(this.sidebarService.content.getValue());
        this.subscriptions.add(this.sidebarService.content.subscribe((content) => this.setContents(content)));
    }
    ngOnInit() {
        this.sidebarCollapsed = this.navService.sidebarCollapsed.getValue();
        this.subscriptions.add(this.navService.sidebarCollapsed.subscribe((sidebarCollapsed) => {
            this.sidebarCollapsed = sidebarCollapsed;
        }));
        this.accessRequestsModuleConfigService.accessRequestsEnabled
            .pipe(take(1))
            .subscribe((accessRequestsEnabled) => (this.accessRequestsEnabled = accessRequestsEnabled));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.contentSubscriptions.unsubscribe();
    }
    setContents(contents) {
        this.contentSubscriptions.unsubscribe();
        const contentItems = contents.map((item, index) => {
            this.contentSubscriptions.add(item.content.subscribe((content) => {
                this.contentItems[index] = content;
            }));
            return item.content.getValue();
        });
        this.contentItems = contentItems;
        this.checkForWarningsAboutShortcuts();
    }
    /**
     * this function checks for content that has the shortcut
     * property when the hasKeyboardShortcutsModule is false
     * and produces a warning for the dev when it finds this
     */
    checkForWarningsAboutShortcuts() {
        // this is only checked in dev mode
        if (!isDevMode) {
            return;
        }
        // there is nothing to check if the hasKeyboardShortcutsModule is true
        if (this.navService.hasKeyboardShortcutsModule) {
            return;
        }
        this.contentItems.forEach((content) => {
            content.rows.forEach((row) => {
                if (row.shortcut) {
                    console.warn('Some of your menu item content has shortcuts defined, but the KeyboardShortcutsModule has not been enabled.  Be sure that your app has the KeyboardShortcutsModule.forRoot() call and that the hasKeyboardShortcutsModule in your nav config is set to true.');
                    return;
                }
            });
        });
    }
    toggleExpanded(item) {
        if (!item.canToggleExpand) {
            return;
        }
        item.expanded = !item.expanded;
    }
    showMe(rowItem) {
        if (this.accessRequestsEnabled) {
            return true;
        }
        if (rowItem.claimType && rowItem.claimValues && rowItem.claimValues.length > 0) {
            return this.claimsService.hasClaim(rowItem.claimType, rowItem.claimValues);
        }
        return true;
    }
}
SidebarContentSectionComponent.ɵfac = function SidebarContentSectionComponent_Factory(t) { return new (t || SidebarContentSectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
SidebarContentSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidebarContentSectionComponent, selectors: [["sidebar-content-section"]], decls: 4, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["class", "sidebar-menu", 3, "cursor", "click", 4, "ngIf"], ["navDynamicContent", "", 3, "componentRef", "item", 4, "ngIf"], ["class", "sidebar-menu nav-tree", 4, "ngIf"], [1, "sidebar-menu", 3, "click"], [1, "header", 3, "innerHtml"], ["navDynamicContent", "", 3, "componentRef", "item"], [1, "sidebar-menu", "nav-tree"], ["class", "treeview", 4, "ngFor", "ngForOf"], [1, "treeview"], [3, "rowItem", 4, "ngIf"], ["class", "treeview-menu menu-open", 3, "display", 4, "ngIf"], [3, "rowItem"], [1, "treeview-menu", "menu-open"]], template: function SidebarContentSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtext(1, "\n        ");
        ɵngcc0.ɵɵtemplate(2, SidebarContentSectionComponent_ng_container_2_Template, 8, 3, "ng-container", 0);
        ɵngcc0.ɵɵtext(3, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.contentItems);
    } }, directives: [ɵngcc6.NgForOf, ɵngcc6.NgIf, NavDynamicContentDirective, NavMenuItemComponent], encapsulation: 2, data: { animation: [
            trigger('childRowAnim', [
                transition(':enter', [style({ height: '0px', opacity: 0, overflow: 'hidden' }), animate('350ms', style({ height: '100%', opacity: 1 }))]),
                transition(':leave', [style({ height: '100%', opacity: 1, overflow: 'hidden' }), animate('200ms', style({ height: '0px', opacity: 0 }))]),
            ]),
        ] } });
SidebarContentSectionComponent.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidebarContentSectionComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('childRowAnim', [
                        transition(':enter', [style({ height: '0px', opacity: 0, overflow: 'hidden' }), animate('350ms', style({ height: '100%', opacity: 1 }))]),
                        transition(':leave', [style({ height: '100%', opacity: 1, overflow: 'hidden' }), animate('200ms', style({ height: '0px', opacity: 0 }))]),
                    ]),
                ],
                selector: `sidebar-content-section`,
                template: `
        <!-- here is where we are repeating contents -->
        <ng-container *ngFor="let content of contentItems">
            <ul
                *ngIf="!content.headerHasComponent"
                class="sidebar-menu"
                (click)="toggleExpanded(content.header)"
                [style.cursor]="content.header.canToggleExpand ? 'pointer' : 'default'"
            >
                <li class="header" [innerHtml]="content.header.content"></li>
            </ul>
            <ng-container
                *ngIf="!sidebarCollapsed && content.headerHasComponent && showMe(content.header)"
                navDynamicContent
                [componentRef]="content.headerComponent"
                [item]="content.header"
            ></ng-container>
            <ul [@childRowAnim] *ngIf="content.header.expanded" class="sidebar-menu nav-tree">
                <li class="treeview" *ngFor="let row of content.rows">
                    <app-nav-menu-item *ngIf="!row.rowHasComponent(content.rowComponent)" [rowItem]="row"></app-nav-menu-item>
                    <ng-container
                        *ngIf="!sidebarCollapsed && row.rowHasComponent(content.rowComponent) && showMe(row)"
                        navDynamicContent
                        [componentRef]="row.getRowComponent(content.rowComponent)"
                        [item]="row"
                    ></ng-container>
                    <ul
                        [@childRowAnim]
                        class="treeview-menu menu-open"
                        [style.display]="row.expanded ? 'block' : 'none'"
                        *ngIf="row.children && row.children.length && row.expanded && showMe(row)"
                    >
                        <li *ngFor="let childRow of row.children">
                            <app-nav-menu-item *ngIf="!childRow.rowHasComponent(content.rowComponent)" [rowItem]="childRow"></app-nav-menu-item>
                            <ng-container
                                *ngIf="!sidebarCollapsed && childRow.rowHasComponent(content.rowComponent) && showMe(childRow)"
                                navDynamicContent
                                [componentRef]="childRow.getRowComponent(content.rowComponent)"
                                [item]="childRow"
                            ></ng-container>
                        </li>
                    </ul>
                </li>
            </ul>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class NavModule {
}
NavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NavModule });
NavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NavModule_Factory(t) { return new (t || NavModule)(); }, providers: [NavService], imports: [[CommonModule, NgbModule, RouterModule, KeyboardShortcutModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavModule, { declarations: function () { return [NavComponent, NavHeaderComponent, NavSidebarComponent, NavMenuItemComponent, AppFooterComponent, NavDynamicContentDirective, HeaderCurrentUserDetailsComponent, HeaderNewTabComponent, HeaderShortcutHelpComponent, HeaderSubmitHelpComponent, SidebarCurrentUserDetailsComponent, SidebarContentSectionComponent]; }, imports: function () { return [CommonModule, NgbModule, RouterModule, KeyboardShortcutModule]; }, exports: function () { return [NavComponent, NavHeaderComponent, NavSidebarComponent, NavMenuItemComponent, AppFooterComponent, HeaderCurrentUserDetailsComponent, HeaderNewTabComponent, HeaderShortcutHelpComponent, HeaderSubmitHelpComponent, SidebarCurrentUserDetailsComponent, SidebarContentSectionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NavComponent,
                    NavHeaderComponent,
                    NavSidebarComponent,
                    NavMenuItemComponent,
                    AppFooterComponent,
                    NavDynamicContentDirective,
                    HeaderCurrentUserDetailsComponent,
                    HeaderNewTabComponent,
                    HeaderShortcutHelpComponent,
                    HeaderSubmitHelpComponent,
                    SidebarCurrentUserDetailsComponent,
                    SidebarContentSectionComponent,
                ],
                exports: [
                    NavComponent,
                    NavHeaderComponent,
                    NavSidebarComponent,
                    NavMenuItemComponent,
                    AppFooterComponent,
                    HeaderCurrentUserDetailsComponent,
                    HeaderNewTabComponent,
                    HeaderShortcutHelpComponent,
                    HeaderSubmitHelpComponent,
                    SidebarCurrentUserDetailsComponent,
                    SidebarContentSectionComponent,
                ],
                imports: [CommonModule, NgbModule, RouterModule, KeyboardShortcutModule],
                providers: [NavService]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderCurrentUserDetailsComponent, HeaderNewTabComponent, HeaderShortcutHelpComponent, HeaderSubmitHelpComponent, NavComponent, NavHeaderComponent, NavMenuItemComponent, NavModule, NavService, NavSidebarComponent, Navbar, getProfileImgPathFromCurrentUser, AppFooterComponent as ɵa, NavDynamicContentDirective as ɵb, SidebarCurrentUserDetailsComponent as ɵc, SidebarContentSectionComponent as ɵd };

//# sourceMappingURL=mt-ng2-nav-module.js.map